import React from 'react';
import Head from 'next/head';

type Props = {
  title?: string;
};

/**
 * Title for header.
 */
const HeaderTitle = (props: Props) => {
  const { title = 'Osmosis' } = props;

  return (
    <Head>
      <title>{title}</title>
    </Head>
  );
};

export default HeaderTitle;
